import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import persistConfig from './persistConfig';
import authReducer from './slices/authSlice'; 
import deliveryReducer from './slices/deliverySlice'; 
import shippingReducer from './slices/shippingSlice'; 

const rootReducer = combineReducers({
  auth: authReducer,
  delivery: deliveryReducer,
  shipping: shippingReducer
  // Add other slices here
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER'],
      },
    }),
});

export const persistor = persistStore(store);

// Define RootState type for type safety
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;